export const NUM_POSTS_PER_BATCH = 20;

// export const API_URL = 'http://127.0.0.1:3000/api';
// export const AVATAR_URL = 'http://127.0.0.1:3000/uploads/avatar/';

export const API_URL = 'https://api.sonichits.co/api';
export const AVATAR_URL = 'https://api.sonichits.co/uploads/avatar/';


